import { atom } from 'recoil';

export const warehouseUserState = atom({
  key: 'warehouse_user',
  default: [],
});
